var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Array.from({ length: _vm.count }, (_, x) => x)),function(i){return _c('div',{key:'loading-'+ _vm._key + '-' + i,class:`infinite-loader draggable-list-item disabled loader-${_vm._key}-${i}`},[_c('div',{staticClass:"placeholder-wave"},[_c('span',{class:['placeholder col-12', 'w-' + _vm.generateRandomIntFromInterval()]})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }